import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Notification } from '@alliance-disposal/transport-types';
import NotificationToggle from './notification-toggle';
// Linked types: when primary type is toggled, linked type is also toggled
export const LINKED_NOTIFICATION_TYPES = {
    WAYSTE_INVOICE_ISSUE_RECEIPT: 'SUBSCRIPTION_INVOICE_CREATED',
    WAYSTE_INVOICE_PAYMENT_RECEIPT: 'SUBSCRIPTION_INVOICE_PAYMENT_RECEIPT',
    // The operations roll-off confirmation mirrors the legacy order confirmation toggle, so the
    // customer manages one "Order Confirmation" preference and both types stay in sync.
    ROLL_OFF_ORDER_CONFIRMATION: 'OPERATIONS_ROLL_OFF_ORDER_CONFIRMATION',
};
// Configuration object for notification types (excludes linked types that are auto-synced)
const NOTIFICATION_CONFIGS = {
    ROLL_OFF_ORDER_CONFIRMATION: {
        label: Notification.CommunicationTypesLabels.ROLL_OFF_ORDER_CONFIRMATION,
        defaultMethod: 'EMAIL',
    },
    ROLL_OFF_ORDER_CANCEL: {
        label: Notification.CommunicationTypesLabels.ROLL_OFF_ORDER_CANCEL,
        defaultMethod: 'SMS',
    },
    ROLL_OFF_DRIVER_ENROUTE: {
        label: Notification.CommunicationTypesLabels.ROLL_OFF_DRIVER_ENROUTE,
        defaultMethod: 'EMAIL',
    },
    WAYSTE_AUTOPAY_RECEIPT: {
        label: Notification.CommunicationTypesLabels.WAYSTE_AUTOPAY_RECEIPT,
        defaultMethod: 'EMAIL',
    },
    ROLL_OFF_DAY_BEFORE_SERVICE_REMINDER: {
        label: Notification.CommunicationTypesLabels.ROLL_OFF_DAY_BEFORE_SERVICE_REMINDER,
        defaultMethod: 'EMAIL',
    },
    ROLL_OFF_DAY_OF_SERVICE_REMINDER: {
        label: Notification.CommunicationTypesLabels.ROLL_OFF_DAY_OF_SERVICE_REMINDER,
        defaultMethod: 'EMAIL',
    },
    ROLLOFF_INVOICE_PAYMENT: {
        label: Notification.CommunicationTypesLabels.ROLLOFF_INVOICE_PAYMENT,
        defaultMethod: 'EMAIL',
    },
    WAYSTE_INVOICE_ISSUE_RECEIPT: {
        label: Notification.CommunicationTypesLabels.WAYSTE_INVOICE_ISSUE_RECEIPT,
        defaultMethod: 'EMAIL',
    },
    WAYSTE_AUTOPAY_FAILURE: {
        label: Notification.CommunicationTypesLabels.WAYSTE_AUTOPAY_FAILURE,
        defaultMethod: 'EMAIL',
    },
    WAYSTE_INVOICE_PAYMENT_RECEIPT: {
        label: Notification.CommunicationTypesLabels.WAYSTE_INVOICE_PAYMENT_RECEIPT,
        defaultMethod: 'EMAIL',
    },
    // Note: SUBSCRIPTION_INVOICE_CREATED and SUBSCRIPTION_INVOICE_PAYMENT_RECEIPT are not shown
    // They are automatically synced when WAYSTE_INVOICE_ISSUE_RECEIPT and WAYSTE_INVOICE_PAYMENT_RECEIPT are toggled
};
// Main component simplified
const ContactNotificationsPreferencesForm = ({ customer, contact, }) => {
    return (_jsxs("div", { className: "inline-flex flex-col items-start justify-start gap-4 rounded-lg border border-slate-300 p-4", children: [Object.entries(NOTIFICATION_CONFIGS).map(([type, config]) => (_jsx(NotificationToggle, { type: type, config: config, customer: customer, contact: contact }, type))), _jsx("p", { className: "text-sm text-neutral-500", children: "Note: Notifications with no designated receiver will be sent to the primary contact via email." })] }));
};
export default ContactNotificationsPreferencesForm;
//# sourceMappingURL=contact-notifications-preferences-form.js.map